var _rect, _rect2, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlipcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 36,
    height: 36,
    rx: 1,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 0.5,
    fill: "black",
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80633 21.584C9.34524 19.4983 10.5649 17.6709 12.2574 16.4131C13.9499 15.1554 16.0105 14.5451 18.0883 14.6863C20.166 14.8276 22.1323 15.7115 23.652 17.1876C25.1717 18.6637 26.1509 20.6406 26.4227 22.7814",
    stroke: "#DEDEDE",
    strokeWidth: 2.08134,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49916 21.6659L7.49648 21.9445C7.64026 22.5009 8.20573 22.8273 8.7595 22.6734L8.49916 21.6659ZM6.3318 17.4368L7.49648 21.9445L9.50184 21.3872L8.33715 16.8796L6.3318 17.4368ZM8.7595 22.6734L13.1062 21.4656L12.5855 19.4505L8.23882 20.6583L8.7595 22.6734Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1927 26.415C25.6538 28.5007 24.4342 30.3282 22.7417 31.5859C21.0492 32.8437 18.9885 33.4539 16.9107 33.3127C14.833 33.1715 12.8668 32.2875 11.347 30.8114C9.82731 29.3353 8.84814 27.3584 8.57636 25.2176",
    stroke: "#DEDEDE",
    strokeWidth: 2.08134,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4999 26.3312L27.5025 26.0526C27.3588 25.4961 26.7933 25.1698 26.2395 25.3236L26.4999 26.3312ZM28.6672 30.5602L27.5025 26.0526L25.4972 26.6098L26.6619 31.1175L28.6672 30.5602ZM26.2395 25.3236L21.8929 26.5315L22.4135 28.5466L26.7602 27.3388L26.2395 25.3236Z",
    fill: "#DEDEDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipcard);
export default __webpack_public_path__ + "static/media/flipcard.512c4240.svg";
export { ForwardRef as ReactComponent };